import jishikaijiang from '../../Jishikaijiang/columns/three';

export default jishikaijiang;



// WEBPACK FOOTER //
// ./src/pages/Trend/History/columns/three.js